import { MainPropSelect } from './getInitialState'

export enum TypesFields {
    array = 'java.lang.Iterable',
    boolean = 'java.lang.Boolean',
    map = 'java.util.Map',
    number = 'java.lang.Double',
    object = 'java.lang.Object',
    string = 'java.lang.String'
}

export interface EventStart {
    fields: {
        [key: string]: TypesFields
    }
    group: string[]
    select: string[]
}

function onStart(status: MainPropSelect, event: EventStart, layer): MainPropSelect {    
    const select = [
        ...new Set([
            ...event?.select.reduce((t, e, i) => {
                const field = String(e)
                
                return (event.fields[field].includes('String') || event.fields[field].includes('Double')) && !field.startsWith('__')
                    ? [...t, field]
                    : t
            }, [])
        ])
    ]
    
    const group = [
        ...new Set([
            ...event?.group.reduce((t, groupName, i) => {
                const field = String(groupName)
                return (event.fields[field].includes('String') || event.fields[field].includes('Double')) &&
                    !field.includes('__')
                    ? [...t, field]
                    : t
            }, [])
        ])
    ]

    const specials = [
        ...new Set([
            ...Object.keys(event?.fields).reduce((t, e, i) => {
                return e.includes('__') ? [...t, e] : t
            }, [])
        ])
    ]
    
    
    return {
        select: {
            ...status.select,
            [layer]: [...select, ...group]
        },
        specials: {
            ...status.specials,
            [layer]: specials
        }
    }
}
export { onStart }
